import EmblaCarousel from 'embla-carousel'
import { addPrevNextBtnsClickHandlers } from './EmblaCarouselArrowButtons'
import { updateSelectedSnapDisplay } from './EmblaCarouselSelectedSnapDisplay'

const OPTIONS = {
  dragFree: true,
  loop: false
}

Drupal.behaviors.swiper = {
  attach() {
    const sliders = document.querySelectorAll('.swiper');
    sliders.forEach((slider) => {
      if (!slider.classList.contains('splide--processed')) {

        const emblaNode = slider;
        const viewportNode = emblaNode.querySelector('.embla__viewport')
        const prevBtnNode = emblaNode.querySelector('.embla__button--prev')
        const nextBtnNode = emblaNode.querySelector('.embla__button--next')
        const snapDisplayNode = emblaNode.querySelector('.embla__selected-snap-display')

        const emblaApi = EmblaCarousel(viewportNode, OPTIONS)

        const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
          emblaApi,
          prevBtnNode,
          nextBtnNode
        )
        updateSelectedSnapDisplay(emblaApi, snapDisplayNode)

        emblaApi.on('destroy', removePrevNextBtnsClickHandlers)

        slider.classList.add('splide--processed');
      }
    });
  },
};





